import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ActionLink = styled(Link)`
  color: ${({ theme: { colors } }) => colors.accentNormal};
`;

export default ActionLink;
